// extracted by mini-css-extract-plugin
module.exports = {"c1y9292n":"c1y9292n","news-title":"news-title","mobile-news-latest":"mobile-news-latest","tweavc8":"tweavc8","a66jnt5":"a66jnt5"};